import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getRideRouteType, IRideDto, NO_VALUE_DISPLAY } from "@ryde/shared";

import { getCourseInfoTranslationKey } from "./course.summary.helpers";

interface ICourseIndicatorTooltip {
  rideDto: Partial<IRideDto>;
}

export const CourseIndicatorTooltip: FC<ICourseIndicatorTooltip> = ({
  rideDto,
}) => {
  const { t } = useTranslation();
  const routeType = useMemo(() => {
    return getRideRouteType(rideDto);
  }, [rideDto]);

  const toolTipContent = useMemo(() => {
    const courseTypeTranslated = routeType
      ? t(`selectListLabel.${routeType}`)
      : NO_VALUE_DISPLAY;
    const courseNameCombined = `${rideDto.courseId}: ${rideDto.courseName}`;
    return `${courseTypeTranslated} | ${courseNameCombined}`;
  }, [rideDto.courseId, rideDto.courseName, routeType, t]);

  const courseTypeInfoTranslationKey = useMemo(() => {
    if (!routeType) {
      return NO_VALUE_DISPLAY;
    }

    return getCourseInfoTranslationKey(routeType);
  }, [routeType]);

  return (
    <>
      <p style={{ fontSize: "13px", fontWeight: 500, marginBottom: "3px" }}>
        {toolTipContent}
      </p>
      {!!rideDto.courseRouteType && (
        <p style={{ fontSize: "11px", fontWeight: 300 }}>
          {t(courseTypeInfoTranslationKey)}
        </p>
      )}
    </>
  );
};
